import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Input.css';

/**
 * Reusable Input Component
 */
const Input = ({
  type = 'text',
  value,
  onChange,
  placeholder,
  disabled = false,
  required = false,
  variant = 'default',
  size = 'medium',
  icon,
  label,
  hint,
  error,
  className = '',
  id,
  name,
  ...props
}) => {
  const getInputClasses = () => {
    const baseClass = type === 'textarea' ? 'Engtable-textarea' : 'Engtable-input';
    const variantClass = variant !== 'default' ? `Engtable-input-${variant}` : '';
    const sizeClass = size !== 'medium' ? `Engtable-input-${size}` : '';
    const errorClass = error ? 'Engtable-input-error' : '';
    
    return [baseClass, variantClass, sizeClass, errorClass, className]
      .filter(Boolean)
      .join(' ');
  };

  const inputProps = {
    type: type === 'textarea' ? undefined : type,
    value,
    onChange,
    placeholder,
    disabled,
    required,
    className: getInputClasses(),
    id: id || name,
    name,
    ...props
  };

  const renderInput = () => {
    if (type === 'textarea') {
      return <textarea {...inputProps} />;
    }
    if (type === 'select') {
      return (
        <select {...inputProps} className={`${getInputClasses()} Engtable-select`}>
          {props.children}
        </select>
      );
    }
    return <input {...inputProps} />;
  };

  const renderWithIcon = () => {
    if (!icon) return renderInput();
    
    return (
      <div className="Engtable-input-with-icon">
        {renderInput()}
        <FontAwesomeIcon icon={icon} className="Engtable-input-icon" />
      </div>
    );
  };

  if (label) {
    return (
      <div className="Engtable-form-group">
        <label htmlFor={id || name}>{label}</label>
        {renderWithIcon()}
        {hint && <div className="Engtable-form-hint">{hint}</div>}
        {error && <div className="Engtable-form-error">{error}</div>}
      </div>
    );
  }

  return renderWithIcon();
};

export default Input;
